import {relatedPopupTriggers} from "./productRelated";
import {productblockHandler} from "./productblock";
import Slider from "./_slider";

const recommendations = document.querySelector('.js-product-recommendations');

if(recommendations) {
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.js-product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;
                }

                if(productRecommendationsSection.childElementCount < 5) {
                    const arrows = [...productRecommendationsSection.parentElement.querySelectorAll('[class*="js-slider-"]')];
                    arrows.map(arrow => arrow.remove());
                }

                relatedPopupTriggers();

                productRecommendationsSection.childNodes.forEach(function(productBlock) {
                    if (productBlock.nodeType === 1) {
                        productblockHandler(productBlock);
                    }
                });


            })
            .then(() => {
                const slider = new Slider(recommendations.closest('.js-slider-delayed'));
            })
            .catch(e => {
                console.error(e);
            });

        window.dispatchEvent(new Event('slider.updated'));
    };

    const productRecommendationsSection = document.querySelector('.js-product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
}
